module.exports = __webpack_public_path__ + "img/c42.8cfc95db.png";